module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/noGamesJoined/nfl/new_survive-6c41eac94af2a1da76edcc81d6f13efe.png";